var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.value,"placeholder":_vm.$tc('selectCompany')},on:{"input":_vm.onChange}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v(" "+_vm._s(option.identificationTypeCode)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }